import * as PracticePreference from '../practice/preference';
import { BaseItem, NullablePartial } from '../common';
import { AppointmentKind, AppointmentStatus } from '../ehrTimeSlot';

export enum StandardIntent {
  Cancel = 'CANCEL',
  Confirm = 'CONFIRM',
}

interface BaseIntent {
  deletedTimestamp: Date | null;
  intent: string;
  replies: string[];
  notificationContentId: string;
  nextNotificationContentId: string | null;
}

export interface Intent extends BaseItem, BaseIntent {}

export type UpsertValues = NullablePartial<
  Pick<BaseIntent, 'intent' | 'replies' | 'nextNotificationContentId'> & {
    id?: string;
  }
>;

import * as Encounter from '../encounter';
import * as Practice from '../practice';
import * as User from '../user';

export type SafeEncounter = Pick<
  Encounter.Encounter,
  'arrivalTime' | 'patientInstructions' | 'startTime' | 'id' | 'kindOfVisit'
> & { status: AppointmentStatus | null };

export interface Appointment {
  encounter: SafeEncounter;
  practice: Practice.SafePractice;
  provider: User.SafeProvider;
  virtualVisit?: boolean;
  isCancellable: boolean;
  rescheduleAppointmentKind?: AppointmentKind;
  preferences: Pick<
    PracticePreference.Preferences,
    | 'previsitConfirmCancelMinimumCancelTime'
    | 'hideEncounterStartTimeByVisitKind'
  >;
}

export interface AppointmentsResponse {
  appointments: Appointment[];
  multipleAppointmentsEnabled?: boolean;
  formSetRedirectEnabled?: boolean;
  skipConfirmationScreen?: boolean;
}

export interface AppointmentReply {
  appointmentStatus: AppointmentStatus;
  encounterId: string;
}
